export default __webpack_public_path__ + "static/media/ico_info_blue.57d254ae.svg";